import Grid from '@material-ui/core/Grid';
import {
    TitleBoxWrap,
    BoxHeader,
    BoxTitle,
    BorderLine
} from '../../pages/home/homeElements'
import {
    CategoryBoxWrap,
    CategoryBoxRow,
    CategoryBoxCol,
    NewsRowList,
    NewsRowItem,
    NewsRowImageLink,
    NewsRowImage,
    NewsRowTitle,
    NewsRowDesc,
    NewsColList,
    NewsColItemFocus,
    NewsColFocusImageLink,
    NewsColFocusImage,
    NewsColFocusBody,
    NewsColFocusTitle,
    NewsColFocusDesc,
    NewsColImageLink,
    NewsColImage,
    NewsColBody,
    NewsColTitle,
    NewsColItem,
    NewsColCategory,
    FlexLayout,
    FlexBody,
} from './categoryBoxElements'
import newsApi from '../../api/newsApi'
import { useEffect, useState } from 'react';

const CategoryBox = ({ct1, ct2, rowfirst}) => {
    const [news, setNews] = useState({
        ct1: [],
        ct2: []
    })
    const [loading, setLoading] = useState(true)
    
    

    useEffect(() => {
        (async () => {
            const response1 = await newsApi.getNewsFromCategory({ _limit: 3, category: ct1 })
            const response2 = await newsApi.getNewsFromCategory({ _limit: 3, category: ct2 })
           
            setNews({
                ct1: response1.news,
                ct2: response2.news
            })
            setLoading(false)
        })()
        
    }, [ct1,ct2])

    if(loading) return <></>

    return (
        <CategoryBoxWrap>
            <BorderLine />
            <FlexLayout>
                <CategoryBoxRow rowfirst={rowfirst}>
                    <TitleBoxWrap>
                        <BoxHeader>
                            <BoxTitle  to='/'>{ct1}</BoxTitle>
                        </BoxHeader>
                        <NewsRowList>
                            <Grid spacing={1} container>
                                {news.ct1.map((news, index) => (
                                    <Grid key={news._id} item sm={12} md={4}>
                                        <NewsRowItem className={index === 0 && 'large'}>
                                            <NewsRowImageLink title={news.title} to={`/news/${news._id}`}>
                                                <NewsRowImage src={news.image} alt={news.title} />
                                            </NewsRowImageLink>
                                            <FlexBody>
                                                <NewsRowTitle className={index !== 0 && 'text-4-row'}  title={news.title} to={`/news/${news._id}`}>{news.title}</NewsRowTitle>
                                                <NewsRowDesc className={index !== 0 && 'hide-on-mobile'}>{news.description}</NewsRowDesc>
                                            </FlexBody>
                                        </NewsRowItem>
                                    </Grid>
                                ))}
                            </Grid>
                        </NewsRowList>
                    </TitleBoxWrap>
                </CategoryBoxRow>
            
                <CategoryBoxCol rowfirst={rowfirst}>
                    <TitleBoxWrap>
                        <BoxHeader>
                            <BoxTitle  to='/'>{ct2}</BoxTitle>
                        </BoxHeader>
                        <NewsColList>
                            <NewsColItemFocus>
                                <NewsColFocusImageLink title={news.ct2[0].title} to={`/news/${news.ct2[0]._id}`}>
                                    <NewsColFocusImage src={news.ct2[0].image} alt={news.ct2[0].title}/>
                                </NewsColFocusImageLink>
                                <NewsColFocusBody>
                                    <NewsColFocusTitle title={news.ct2[0].title} to={`/news/${news.ct2[0]._id}`}>{news.ct2[0].title}</NewsColFocusTitle>
                                    <NewsColFocusDesc>{news.ct2[0].description}</NewsColFocusDesc>
                                </NewsColFocusBody>
                            </NewsColItemFocus>
                            {news.ct2.slice(1).map((news, index) => (
                                <NewsColItem key={news._id}>
                                    <NewsColImageLink title={news.title} to={`/news/${news._id}`}>
                                        <NewsColImage src={news.image} alt={news.title}/>
                                    </NewsColImageLink>
                                    <NewsColBody>
                                        <NewsColTitle title={news.title} to={`/news/${news._id}`}>{news.title}</NewsColTitle>
                                        <NewsColCategory className='hide-on-mobile' to='/'>{news.category}</NewsColCategory>
                                    </NewsColBody>
                                </NewsColItem>
                            ))}
                        </NewsColList>
                    </TitleBoxWrap>
                </CategoryBoxCol>
                
            </FlexLayout>
        </CategoryBoxWrap>
    )
}

export default CategoryBox
